import {
  Box,
  Dialog,
  DialogTitle,
  IconButton,
  styled,
  TextField,
} from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 30,
    backgroundColor: theme.palette.common.white,
    padding: '40px',
    minHeight: 'auto',
    [theme.breakpoints.down('xl')]: {
      minWidth: 600,
      '& .css-biqaug': {
        margin: '48px 60px',
      },
    },
    [theme.breakpoints.up('xl')]: {
      minWidth: 740,
    },
  },
  '& .MuiDialog-paperScrollPaper': {
    '&::-webkit-scrollbar': {
      width: 10,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.dark,
      borderRadius: 10,
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
      },
    },
    '&::-webkit-scrollbar-track': {
      margin: '60px 0',
    },
  },
}));

export const DialogContainer = styled(Box)(() => ({}));

export const TopContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  margin: '-18px -18px 0 0',
  height: 'fit-content',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.common.grey,
    '&:hover': {
      color: `${theme.palette.common.grey}80`,
    },
  },
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

export const WarningMessage = styled('span')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  background: '#FFFAEA',
  borderRadius: 8,
  padding: 16,
  fontSize: 16,
  color: '#344054',

  svg: {
    color: '#EF9A11',
  },

  '.message-title': {
    lineHeight: '150%',
    fontWeight: 600,
  },

  '.message-subtitle': {
    lineHeight: '140%',
  },
}));

export const Title = styled(DialogTitle)(() => ({
  color: '#1A1A1A',
  fontfamily: 'Montserrat',
  fontSize: '28px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: 'normal',
}));

export const ReasonBox = styled(Box)(() => ({
  position: 'relative',
  margin: '32px 0 0 0',
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    borderRadius: 8,
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-disabled': {
      background: '#F5F5F4',
    },

    '&:hover fieldset': {
      borderColor: '#9CA3AF',
    },

    '&.Mui-focused fieldset': {
      borderColor: theme.palette.secondary.main,
      borderWidth: '2px',
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.palette.secondary.main,
  },
}));

export const ClientTextField = styled(StyledTextField)(() => ({
  margin: '32px 0 0 0',
}));

export const ReasonTextField = styled(StyledTextField)(() => ({
  '& .MuiOutlinedInput-root': {
    alignItems: 'flex-start',
    paddingBottom: '24px',
  },

  '& textarea': {
    paddingRight: '60px',
  },
}));

export const Caption = styled('caption')(() => ({
  position: 'absolute',
  right: 14,
  bottom: 10,
  color: '#9CA3AF',
  fontSize: '14px',
  pointerEvents: 'none',
}));

export const ContainerInfo = styled('ul')(() => ({
  margin: '24px 0 0 0',
}));

export const InfoItem = styled('li')(() => ({
  color: '#1A1A1A',
}));

export const ContainerButtons = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 32,
  margin: '32px 0 0 0',
}));
